import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
import Utilities from "utilities/global/sparta-events-utility/2.3.3/js/utilities";



const regex = /[(.)+([)+(\])+]/gi;


const replacementChars = {
  '.': '/',
  '[': '(',
  ']': ')',
};

const EVENTS = {
  SPA_PARAMS_LOADED: 'SPA_PARAMS_LOADED.spartaEventsUtility',
  APP_CONTAINER_LOADED: 'APP_CONTAINER_LOADED.spartaEventsUtility',
  APP_CONTEXT_LOADED: 'APP_CONTEXT_LOADED.spartaEventsUtility',
};




class SpartaEventsUtility {



  constructor() {
    this.subscriptions = {};
    this.alreadyBeenPublished = {};
  }





  get EVENTS() {
    return EVENTS;
  }










  sub(event, callback = () => {}, retroactive = false) {
    if (typeof event !== 'string') {
      return null;
    }

    const [eventName, nameSpace = 'default'] = event.split(':');
    const escapedEventName = eventName.replace(regex, matched => replacementChars[matched]);
    const subPath = _.get(this.subscriptions, `${escapedEventName}[${nameSpace}]`, null);
    const token = `${event}_${Utilities.uuidString()}`;
    if (!subPath) {
      _.set(this.subscriptions, `${escapedEventName}[${nameSpace}]`, []);
    }
    this.subscriptions[`${escapedEventName}`][nameSpace].push({ callback, token });

    if (retroactive && this.alreadyBeenPublished[`${escapedEventName}`]) {
      const args = this.alreadyBeenPublished[`${escapedEventName}`];
      callback({ event, args, data: args });
    }

    return token;
  }






  unsubByEvent(event) {
    if (!event || typeof (event) !== 'string') {
      return;
    }
    const [eventName, nameSpace] = event.split(':');
    const escapedEventName = eventName.replace(regex, matched => replacementChars[matched]);

    if (!nameSpace) {
      delete this.subscriptions[escapedEventName];
    } else {
      delete this.subscriptions[escapedEventName][nameSpace];
    }
  }







  unsubByToken(token) {
    if (typeof (token) !== 'string' || !token || !token.includes('_')) {
      return null;
    }

    const [eventName, nameSpace = 'default'] = token.split('_')[0].split(':');
    const escapedEventName = eventName.replace(regex, matched => replacementChars[matched]);
    const subscriptions = _.get(this.subscriptions, `${escapedEventName}[${nameSpace}]`, []);

    return subscriptions.some((sub, idx) => {
      if (sub.token === token) {
        subscriptions.splice(idx, 1);
        return true;
      }
      return false;
    });
  }








  unsubWidgetByToken(token) {
    if (typeof token !== 'string' || !token || !token.includes('_')) {
      return null;
    }

    const eventName = token.substring(0, token.lastIndexOf('_')).replace('.', '/');
    const escapedEventName = eventName.replace(regex, matched => replacementChars[matched]);
    const subscriptions = _.get(this.subscriptions, `${escapedEventName}[default]`, []);

    return subscriptions.some((sub, idx) => {
      if (sub.token === token) {
        subscriptions.splice(idx, 1);
        return true;
      }
      return false;
    });
  }







  pub(event, data) {
    if (typeof (event) !== 'string') {
      return;
    }








    try {
      document.dispatchEvent(new CustomEvent(event, { detail: data }));
    } catch (e) {

    }

    const [eventName, nameSpace] = event.split(':');
    const escapedEventName = eventName.replace(regex, matched => replacementChars[matched]);

    let subscriptions = _.get(this.subscriptions, escapedEventName, {});

    if (nameSpace) {
      subscriptions = _.get(subscriptions, nameSpace, {});
    }

    let callbackMaps = [];

    Object.keys(subscriptions).forEach((sub) => {
      callbackMaps = callbackMaps.concat(subscriptions[sub]);
    });

    this.alreadyBeenPublished[escapedEventName] = data;
    callbackMaps.forEach((obj) => {
      obj.callback({ event, data });
    });
  }
}

export default new SpartaEventsUtility();
